import { login, logout, getInfo } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { setCookie } from '@/utils/support'
import Cookies from 'js-cookie'
import { replaceUserRoutes } from '@/router/index'
import { measureAuthStage, sessionChangedError } from '@/utils/authFlow'

const user = {
  state: {
    token: getToken(),
    name: '',
    avatar: '',
    roles: [],
    rolesIds: [],
    sessionVersion: 0
  },

  mutations: {
    RESET_USER_STATE: state => {
      state.token = ''
      state.name = ''
      state.avatar = ''
      state.roles = []
      state.rolesIds = []
      state.sessionVersion++
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_ROLESIDS: (state, rolesIds) => {
      state.rolesIds = rolesIds
    }
  },

  actions: {
    // 登录
    async Login({ commit, dispatch, state }, userInfo) {
      const username = userInfo.username.trim()
      const resetting = dispatch('FedLogOut')
      const version = state.sessionVersion
      await resetting
      if (version !== state.sessionVersion) throw sessionChangedError()
      const response = await measureAuthStage('login', () => login(username, userInfo.password))
      if (version !== state.sessionVersion) throw sessionChangedError()
      const data = response.data
      if (!data || !data.token || !data.tokenHead) throw new Error('登录响应异常，请重试。')
      const tokenStr = data.tokenHead + data.token
      setToken(tokenStr)
      commit('SET_TOKEN', tokenStr)
    },

    // 获取用户信息
    async GetInfo({ commit, state }) {
      const token = getToken()
      const version = state.sessionVersion
      const response = await measureAuthStage('user-info', () => getInfo())
      if (token !== getToken() || version !== state.sessionVersion) throw sessionChangedError()
      const data = response.data
      if (!data || !Array.isArray(data.roles) || !data.roles.length || !Array.isArray(data.menus)) {
        throw Object.assign(new Error('账号权限信息不完整，请联系管理员。'), { code: 'AUTH_INFO_INVALID' })
      }
      commit('SET_ROLES', data.roles)
      commit('SET_ROLESIDS', data.rolesIds || [])
      setCookie('userId', data.userId)
      commit('SET_NAME', data.username)
      commit('SET_AVATAR', data.icon)
      return response
    },

    GetInfoNew({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo().then(response => {
          const data = response.data

          // 处理 menus 数组
          if (data.menus && Array.isArray(data.menus)) {
            const parentMenu = data.menus.find(menu => menu.parentId === 0);
            const homeMenu = data.menus.find(menu => menu.parentId === 0 && menu.title === '首页');
            console.log("父菜单的name: ", homeMenu); // 输出父菜单的 name

            if (homeMenu) {
                setCookie('SET_COMBINED_NAME', 'home'); // 将第一个组合好的 name 存储在 cookie 中
                
              
            }else{
              const subMenus = data.menus.filter(menu => menu.parentId === parentMenu.id);
              const combinedNames = subMenus.map(subMenu => `${parentMenu.name}/${subMenu.name}`);
              const firstCombinedName = combinedNames[0]; // 获取第一个组合好的 name
              setCookie('SET_COMBINED_NAME', firstCombinedName); // 将第一个组合好的 name 存储在 cookie 中
            }
          }
          resolve(response)

        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    async LogOut({ dispatch, state }) {
      const version = state.sessionVersion
      await logout(state.token)
      if (version === state.sessionVersion) await dispatch('FedLogOut')
    },

    // 前端 登出
    FedLogOut({ commit }) {
      commit('RESET_USER_STATE')
      commit('RESET_ROUTERS')
      removeToken()
      Cookies.remove('userId')
      Cookies.remove('SET_COMBINED_NAME')
      replaceUserRoutes()
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js